const InstallationDetailPage = () => (
  <div className="p-4">
    <h1 className="text-xl font-bold">Installation Details</h1>
  </div>
)
export default InstallationDetailPage
